import React, { FC } from 'react';
import { Layout } from 'antd';

const { Footer: FooterLayout } = Layout;

const Footer: FC = () => <FooterLayout className='footer'> JustLearn ©2020 Created by Kiran LM</FooterLayout>;

export default Footer;
